module.exports = __webpack_public_path__ + "img/manage-booking.44b3d32d.png";